import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PartnerDTO } from '@lkp/parking-sdk';

@Component({
    selector: 'app-navbar-admin',
    templateUrl: './navbar-admin.component.html',
    styleUrls: ['./navbar-admin.component.scss'],
    standalone: false
})
export class NavbarAdminComponent {
  @Input() partners?: PartnerDTO[];
  @Output() partnerSelected = new EventEmitter<PartnerDTO>();

  partnerIsActiveNow = false; // Can't user routerLinkActive in the partner menu. This is a workaround.

  setCurrentPartner(partner: PartnerDTO) {
    if (partner) {
      this.partnerIsActiveNow = true;
      this.partnerSelected.emit(partner);
    }
  }
}
